import React, { useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import {
  Avatar,
  IconButton,
  Box,
  Typography,
  LinearProgress,
  Button
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { pink } from "@mui/material/colors";
import DownloadIcon from 'icons/drawable/ic_download.svg';

import "./PDFBlock.css";

function PDFBlockView({ idx, block, allowEditing, onEdit }) {
  const [namedUrls, setNamedUrls] = React.useState();
  const [progress, setProgress] = React.useState();

  useEffect(() => {
    if (block.data) {
      _checkResourcePrepStatus(block.data);
    }
  }, []);

  function getPdfAreaName() {
    return "pdf-area-" + block.name;
  }

  const _setUrls = async (resourceId) => {
    const resources = await global.dipClient.getResources([ resourceId ]);
    if (resources && resources.length > 0 && resources[0].status === 'READY') {
      if (resources[0].namedUrls) {
        console.log("_setUrls: urls = " + JSON.stringify(resources[0].namedUrls));
        setNamedUrls(resources[0].namedUrls);
        return true;
      }
    }
    return false;
  };

  const _checkResourcePrepStatus = async (resourceId) => {
    console.log("_checkResourcePrepStatus: resourceId = " + resourceId);

    if (await _setUrls(resourceId)) return;

    setProgress(0);
    while (true) {
      const resourceStatus = await global.dipClient.getResourceStatus([ resourceId ]);
      if (!resourceStatus) {
        console.log("_checkResourcePrepStatus: invalid resourceStatus");
        break;
      }
      if (resourceStatus[0].status === 'READY') break;

      const p = resourceStatus[0].prepProgress ? resourceStatus[0].prepProgress : 0;
      console.log("_checkResourcePrepStatus: progress = " + p);
      setProgress(p);

      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    setProgress(100);

    if (await _setUrls(resourceId)) return;
  };

  function getEditButton() {
    if (allowEditing) {
      return (
        <IconButton
          style={{
            position: "absolute",
            top: 20,
            left: 20,
          }}
          size="large"
          onClick={(e) => onEdit(block)}
        >
          <Avatar sx={{ bgcolor: pink[500] }}>
            <EditIcon />
          </Avatar>
        </IconButton>
      );
    }
    return null;
  }

  const renderPdf = () => {
    if (!namedUrls) {
      if (progress === undefined) return null;
      return (
        <Box
          id={`${getPdfAreaName()}-transcoding`}
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "100%",
            height: `${(140 / 360) * 100}vw`,
            backgroundColor: "black",
          }}
        >
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="body1" color="textSecondary">
              {"PDF을 변환 중입니다"}
            </Typography>
            <LinearProgress
              sx={{ width: "100%", marginTop: "16px" }}
              color="secondary"
            />
          </Box>
        </Box>
      );
    }
    return renderCarousel();
  };

  const renderCarousel = () => {
    return (
      <Carousel
        className={"carousel"}
        infiniteLoop={false}
        showIndicators={false}
        showThumbs={false}
        showArrows={true}
        autoPlay={false}
        showStatus={false}
        axis={"horizontal"}
        dynamicHeight={false}
        swipeable={true}
        emulateTouch={true}
        // renderIndicator={(onClickHandler, isSelected, index, label) => {
        //   return (
        //     <div
        //       style={{
        //         // width: '6px',
        //         // height: '6px',
        //         // borderRadius: '6px',
        //         // backgroundColor: isSelected ? 'rgb(101, 101, 101)' : 'rgb(184, 184,184)',
        //         // marginBottom: '0px',
        //         // // marginTop: '12px',
        //         // marginInline: '3px',
        //         // display: 'inline-block',
        //       }}
        //     />
        //   );
        // }}
        // centerMode={true}
      >
        {namedUrls?.image?.map((obj, index) => {
          return (
            <img
              key={`carousel-index-${index}`}
              alt={"images"}
              src={obj}
              width={"100%"}
              height={"250px"}
              style={{
                objectFit: "contain",
              }}
            />
          );
        })}
      </Carousel>
    );
  };

  const handleDownload = async (e) => {
    console.log('handleDownload / url = ', namedUrls);
    const link = document.createElement("a");
    link.href = namedUrls.download[0];
    link.click();
  }

  const renderDownloadButton = () => {
    if (namedUrls) {
      return (
        <Button sx={{
          position:'absolute',
          left: '0px',
          top: '0px',
          width: '30px',
          height: '30px'
        }}
        onClick={handleDownload}
        >
          <img src={DownloadIcon} alt='download icon' style={{
            width: '30px',
            height: '30px',
            objectFit:'contain'}} />
        </Button>
      );
    }
  }

  const style = {
    transform: `translateX(${block.translationX}%) scale(${block.scale})`,
  };

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: block.backgroundColor,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div id={block.name} style={style}>
        {renderPdf()}
        {renderDownloadButton()}
      </div>
      {getEditButton()}
    </div>
  );
}

export default PDFBlockView;
